import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Menu, Popover, Row, Spin } from "antd";
import ButtonGroup from "antd/es/button/button-group";

import Swal from "sweetalert2";

import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

const EditCategoryList = ({
	selectCategory,
	setSelectCategory,
	categoryList,
	setCategoryList,
	selectKey,
	setSelectKey,
	setLinkList,
	setProductList,
	getCategory,
}) => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const isLoading = useSelector((state) => state.common.loading);
	const [listLoading, setListLoading] = useState(false);
	const [addModalShow, setAddModalShow] = useState(false);

	const mainList =
		user?.id === 9 || user?.partners_id === 9
			? [
					{
						list: "ingredientList",
						// name: "성분별",
						name: "고민별",
					},
			  ]
			: [
					{
						list: "ingredientList",
						name: "성분별",
					},
					{
						list: "functionList",
						name: "고민별",
					},
					{
						list: "combinationList",
						name: "조합별",
					},
			  ];

	const [newCategory, setNewCategory] = useState("");

	/**
	 * 카테고리 추가 버튼 -> 저장
	 */
	const addCategoryBtn = () => {
		let type =
			selectCategory === 0
				? "ingredient"
				: selectCategory === 1
				? "function"
				: "category";
		let list = categoryList?.[mainList[selectCategory].list];
		let filterList = list?.filter(
			(item) => item?.[`${type}_name`] === newCategory
		);
		if (filterList?.length) {
			alert("이미 존재하는 카테고리명입니다.");
		} else {
			addNewCategory();
		}
	};

	/**
	 * 카테고리 새로 생성
	 */
	const addNewCategory = () => {
		if (newCategory?.length) {
			setSelectKey({
				category_name: newCategory,
			});
			setLinkList([]);
			setProductList([]);
			setAddModalShow(false);
		} else {
			alert("카테고리명을 입력해주세요.");
		}
	};

	/**
	 * 해당 카테고리 삭제
	 * @returns {Promise<void>}
	 */
	const deleteCategory = async () => {
		if (selectKey?.id) {
			Swal.fire({
				customClass: "alert-custom",
				text: `해당 카테고리를 삭제하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					if (!selectKey?.is_mall) {
						setIsLoading(true);
						let param = {
							categoryId: selectKey.id,
							categoryType: mainList[selectCategory].list?.replace("List", ""),
							userId:
								user?.role === "level_1" || user?.role === "super_admin"
									? user?.id
									: user?.partners_id,
						};
						const res = await partnersApi.deleteCategoryList(param);
						if (res.code === 200) {
							getCategory("delete");
						} else {
							setIsLoading(false);
						}
					} else {
						let category_name = selectKey?.ingredient_name
							? selectKey?.ingredient_name
							: selectKey?.function_name
							? selectKey?.function_name
							: selectKey?.category_name;
						alert(
							category_name +
								" 카테고리는 기본 카테고리 항목으로\n" +
								"삭제가 불가합니다."
						);
					}
				}
			});
		}
	};

	/**
	 * 정렬 순서 변경하기
	 * @param e
	 */
	const handleOrder = async (e) => {
		if (selectKey?.id) {
			const param = {
				id: selectKey?.id,
				category_id: selectKey?.ingredient_id
					? selectKey?.ingredient_id
					: selectKey?.function_id,
				category_type: mainList[selectCategory].list?.replace("List", ""),
				sort_method: e.currentTarget.id,
				influencer_id:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
				updated_by: user?.id,
			};
			const res = await partnersApi.postCategoryOrder(param);
			if (res.code === 200) {
				// getCategory("order");
				// getCategory();
				setListLoading(true);
				let param = {
					influencerId:
						user?.role === "level_1" || user?.role === "super_admin"
							? user?.id
							: user?.partners_id,
				};
				if (selectCategory === 0) {
					const res = await partnersApi.readCategoryList(param);
					if (res.code === 200) {
						setCategoryList({
							...categoryList,
							ingredientList: res.result?.totalIngredientList,
						});
					}
				} else if (selectCategory === 1) {
					const res = await partnersApi.readCategoryList(param);
					if (res.code === 200) {
						setCategoryList({
							...categoryList,
							functionList: res.result?.functionList,
						});
					}
				} else {
					const rsq = await partnersApi.readCombinationList(param);
					if (rsq.code === 200) {
						setCategoryList({
							...categoryList,
							combinationList: rsq.result,
						});
					}
				}
				setListLoading(false);
			}
		}
	};

	const popoverContent = (
		<Form>
			<Form.Item
				colon={false}
				style={{
					width: "100%",
					margin: 0,
				}}
				labelAlign="left"
			>
				<Input
					type={`text`}
					placeholder={`카테고리명을 입력해주세요.`}
					allowClear={true}
					value={newCategory}
					onChange={(e) => setNewCategory(e.target.value)}
					onPressEnter={addCategoryBtn}
				/>
			</Form.Item>
			<p>* 카테고리명은 작성 후 수정이 가능합니다.</p>
			<ButtonGroup>
				<Button size={`small`} onClick={() => setAddModalShow(!addModalShow)}>
					취소
				</Button>
				<Button size={`small`} className={`success`} onClick={addCategoryBtn}>
					저장
				</Button>
			</ButtonGroup>
		</Form>
	);

	return (
		<div className={`edit-channel-category-list-component`}>
			<div className={`list-component-div`}>
				<div
					className={`list-component-title`}
					style={
						user?.id === 9 || user?.partners_id === 9
							? {
									paddingBottom: 0,
							  }
							: {}
					}
				>
					{mainList?.map((item, idx) => (
						<Button
							className={`${selectCategory === idx ? "select" : ""}`}
							key={`select-main-${idx}`}
							onClick={() => {
								setSelectCategory(idx);
								setSelectKey({});
							}}
						>
							{item.name}
						</Button>
					))}
				</div>
				<Menu
					className={`list-component-body`}
					selectedKeys={[`${selectKey?.id}`]}
					style={{
						position: "relative",
					}}
				>
					{isLoading ? (
						<Spin
							style={{ margin: "auto", width: "100%", paddingTop: "2em" }}
						/>
					) : (
						<>
							{categoryList?.[mainList[selectCategory].list]?.length > 0 ? (
								<>
									{listLoading && (
										<Spin
											style={{
												margin: "auto",
												width: "100%",
												paddingTop: "2em",
												position: "absolute",
												zIndex: 1,
												top: "50%",
												transform: "translateY(-50%)",
												left: 0,
												right: 0,
											}}
										/>
									)}
									{categoryList?.[mainList[selectCategory].list]?.map(
										(item, idx) => (
											<Menu.Item
												key={`${item?.id}`}
												id={`${item?.id} ${idx}`}
												onClick={() => {
													if (!listLoading) {
														setSelectKey(item);
													}
												}}
											>
												<div className={`list-category-title-div`}>
													<p className={`${!item.is_show ? "title-gray" : ""}`}>
														{selectCategory === 0
															? item.ingredient_name
															: selectCategory === 1
															? item.function_name
															: item.category_name}
													</p>
													{item.is_hot && <p className={`hot`}>HOT</p>}
													{item.is_best && <p className={`best`}>BEST</p>}
													{!item.is_show && <p className={`not-show`}>off</p>}
												</div>
											</Menu.Item>
										)
									)}
								</>
							) : (
								<Row
									align={"middle"}
									style={{
										width: "100%",
										flexDirection: "column",
										padding: "3em 0",
									}}
								>
									<img
										src={`/assets/images/warning.png`}
										alt={`warning-icon`}
										style={{
											width: "3em",
											height: "auto",
										}}
									/>
									<p
										style={{
											marginTop: "1em",
											color: "#adb5bd",
											fontSize: "1.1em",
											fontWeight: 500,
										}}
									>
										등록된 카테고리가 없습니다.
									</p>
								</Row>
							)}
						</>
					)}
				</Menu>
				<div className={`list-component-footer`}>
					<Popover
						content={popoverContent}
						title={
							<Row justify={`space-between`} align={"middle"}>
								<span>카테고리명 추가</span>
								<img
									src={`/assets/images/channel/close.png`}
									alt={`추가`}
									style={{
										width: 20,
										height: 20,
										cursor: "pointer",
									}}
									onClick={() => setAddModalShow(false)}
								/>
							</Row>
						}
						open={addModalShow}
						onOpenChange={() => {
							setAddModalShow(!addModalShow);
							setNewCategory("");
						}}
						trigger="click"
						className={`category-add-popover`}
						overlayClassName={"category-add-popover-overlay"}
						placement={`topLeft`}
					>
						<Button
							// onClick={addNewCategory}
							// onClick={() => setAddModalShow(true)}
							disabled={isLoading || listLoading}
						>
							<img
								src={`/assets/images/products/add.png`}
								alt={`성분별 카테고리 목록 추가`}
								style={{
									width: 13,
									height: 13,
								}}
							/>
							추가
						</Button>
					</Popover>
					<Button onClick={deleteCategory} disabled={isLoading || listLoading}>
						<img
							src={`/assets/images/products/delete.png`}
							alt={`추가`}
							style={{
								width: 13,
								height: 13,
							}}
						/>
						삭제
					</Button>
				</div>
			</div>

			{/* 정렬 순서 변경 */}
			<div className={`list-component-order`}>
				<ButtonGroup>
					<Button
						size={`small`}
						onClick={handleOrder}
						id={`up`}
						disabled={isLoading || listLoading}
					>
						<img
							src={`/assets/images/products/up.png`}
							alt={`추가`}
							style={{
								width: 13,
								height: 13,
							}}
						/>
					</Button>
					<Button
						size={`small`}
						onClick={handleOrder}
						id={`down`}
						disabled={isLoading || listLoading}
					>
						<img
							src={`/assets/images/products/down.png`}
							alt={`추가`}
							style={{
								width: 13,
								height: 13,
							}}
						/>
					</Button>
					<Button
						size={`small`}
						onClick={handleOrder}
						id={`top`}
						disabled={isLoading || listLoading}
					>
						<img
							src={`/assets/images/products/top.png`}
							alt={`추가`}
							style={{
								width: 13,
								height: 13,
							}}
						/>
					</Button>
					<Button
						size={`small`}
						onClick={handleOrder}
						id={`bottom`}
						disabled={isLoading || listLoading}
					>
						<img
							src={`/assets/images/products/bottom.png`}
							alt={`추가`}
							style={{
								width: 13,
								height: 13,
							}}
						/>
					</Button>
				</ButtonGroup>
				<p>* 카테고리 전시 순서를 변경할 수 있습니다.</p>
			</div>
		</div>
	);
};
export default EditCategoryList;
